"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _Headers = require("./Headers");
Object.keys(_Headers).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _Headers[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _Headers[key];
        }
    });
});
var _DefaultHeaders = require("./DefaultHeaders");
Object.keys(_DefaultHeaders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _DefaultHeaders[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _DefaultHeaders[key];
        }
    });
});
var _FetchGraphqlOptions = require("./FetchGraphqlOptions");
Object.keys(_FetchGraphqlOptions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _FetchGraphqlOptions[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _FetchGraphqlOptions[key];
        }
    });
});
var _FetchInfo = require("./FetchInfo");
Object.keys(_FetchInfo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _FetchInfo[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _FetchInfo[key];
        }
    });
}); //# sourceMappingURL=index.js.map
